export class ARStoryOption {
    id: string;
    label: string;
    text?: string;
    expanded: boolean;
    animation: any;
    textHash?: string;
    options: ARStoryOption[] = [];
    audioFile?: any;
    animUpload: boolean = false;
    animFile?: any;
    audioText?: AudioText;
    callToAction?: boolean;
    buttonName?: string;
    url?: string;
    textBehavior: 'stop' | 'loop' = 'stop';
    animationBehavior: 'idle' | 'loop' = 'loop';
    animationsEnabled: boolean = true;
    weatherAnnouncement: boolean = false;

    constructor() {
        this.id = Math.random().toString(36).slice(2, 8);
        this.label = "";
        this.text = "";
        this.expanded = true;
        this.options = [];
        this.animationsEnabled = true;
    }
}

export class AudioText {
    characters: string[];
    characterStartTimes: number[];
    characterEndTimes: number[];
}